import axios from "axios"
import { VUE_APP_SIT_PEDIDOS_API_URL, VUE_APP_NAME } from '@/commons/config';

//import TransportadoraAuthService from "@/services/transportadora.auth.service";
const AUTH = `${VUE_APP_NAME}-transportadora-auth`;

const { token = null } = JSON.parse(localStorage.getItem(AUTH)) || {};


export const apiUpload = axios.create({baseURL: VUE_APP_SIT_PEDIDOS_API_URL, headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` }})
